<template>
  <div>
    <div class="flex justify-start items-end flex-wrap gap-12 mb-3">
      <!-- <div v-if="accountLevel == 'ib' || accountLevel == 'fm' || accountLevel == 'ccp'" class="col-auto mb-2 text-left">
						<FilterClient class="d-inline-block"
							filterId="transaction"
							@changeFilterClient="changeFilterClientTransaction"
							:clients_prop="listClients"
						>
						</FilterClient>
					</div> -->

      <div class="flex--grow-1">
        <ReportsNav />
      </div>

      <div class="flex items-end flex-wrap gap-12">
        <div v-if="$store.getters.paymentMethod == 'rped'" class="text-left">
          <FilterOrderType @changeFilterOrderType="setTransactions">
          </FilterOrderType>
        </div>

        <div class="text-left">
          <FilterDateAndType class="d-inline-block" @changeFilterDateAndType="changeFilterDateAndTypeTransaction"
            :dateOnly_prop="true">
          </FilterDateAndType>
        </div>

        <div v-if="$store.getters.paymentMethod == 'rped'" class="text-left">
          <FilterContract class="d-inline-block" @changeFilterContract="changeFilterContractTransaction"
            filterId="transaction" :forceCheckedContracts_prop="$store.state.filterContractTransactions">
          </FilterContract>
        </div>

        <div v-if="accountLevel == 'ib' || accountLevel == 'fm'" class="text-left">
          <FilterTransactionStatus class="d-inline-block" @changeFilterTransactionStatus="setTransactions"
            filterId="transaction">
          </FilterTransactionStatus>
        </div>

        <!-- <div class="text-left">
          <ButtonExportToCSV :orderType_prop="orderType_export" :contractsParam_prop="contractsParam_export"
            :startDate_prop="startDate_export" :endDate_prop="endDate_export"
            :selectedClientTransaction_prop="selectedClientTransaction_export"></ButtonExportToCSV>
        </div> -->
      </div>

      <!-- <div class="col-auto mb-2 text-left">
						<ExportAsButton class="d-inline-block">
						</ExportAsButton>
					</div> -->
    </div>

    <div class="flex gap-3 bg-white-2 py-2 px-4 mb-3">
      <div>
        <IconInfo2 height_prop="1.25rem" width_prop="1.25rem" />
      </div>
      <div class="text-xs text-black self-center">
        Orders that experience a partial fill can be identified by a single order ID having more than one transaction
        ID. Please monitor periodically.
      </div>
    </div>

    <div class="text-sm text-white mb-4">
      <table class="w-full text-center">
        <thead>
          <tr class="font-medium bg-grey-1 bg-clip-padding border-0 border-solid border-b-2 border-b-transparent">
            <th class="px-2.5 py-5">Order <br> Direction</th>
            <th v-if="$store.getters.paymentMethod == 'rped'" class="px-2.5 py-5">Order <br> Type</th>
            <th class="px-2.5 py-5">Transaction <br> Date</th>
            <th class="px-2.5 py-5">
              Order ID
              <span v-if="$store.getters.paymentMethod == 'gopay'">/
                <br />
                <span class="text-nowrap">Payment ID</span>
              </span>
            </th>
            <th class="px-2.5 py-5">Transaction ID</th>
            <th v-if="$store.getters.paymentMethod == 'rped'" class="px-2.5 py-5">Contract</th>
            <!-- <th v-if="$store.getters.paymentMethod == 'rped'" class="px-2.5 py-5">HUB</th> -->
            <!-- <th class="px-2.5 py-5">HIN</th> -->
            <th class="px-2.5 py-5">Total Gram</th>
            <th class="px-2.5 py-5">Price per Gram</th>
            <th class="px-2.5 py-5">Metal Value of Trade</th>
            <th v-if="$store.getters.paymentMethod == 'rped'" class="px-2.5 py-5">Fee</th>
            <th v-if="$store.getters.paymentMethod == 'rped'" class="px-2.5 py-5">Tax</th>
            <th class="px-2.5 py-5">Settlement Amount</th>
            <th class="px-2.5 py-5">Status</th>
            <th class="px-2.5 py-5">&nbsp;</th>
            <th v-if="environment == 'development'" class="px-2.5 py-5">UNREALIZED <br> PNL</th>
            <th v-if="environment == 'development'" class="px-2.5 py-5">REALIZED <br> PNL</th>
          </tr>
        </thead>

        <tbody v-if="transactionsStatus == 'loading'" class="bg-grey-1">
          <tr>
            <td class="text-center py-5" :colspan="$store.getters.paymentMethod == 'gopay' ? 14 : 17">
              <Loader size_prop="10em"></Loader>
            </td>
          </tr>
        </tbody>

        <tbody v-else-if="transactionsStatus == 'idle' || transactionsStatus == 'success'" class="bg-grey-1">
          <tr v-if="transactions.length < 1">
            <td colspan="18" class="text-center py-6">No data available in table</td>
          </tr>

          <template v-else>
            <tr v-for="transaction in transactions" class="c-row-table" :key="transaction._id">
              <td :class="`text-center py-4 ${transaction.direction == 'buy' ? 'text-success' : 'text-danger'}`">
                {{ transaction.direction == 'buy' ? 'Beli' : 'Jual' }}
              </td>

              <td v-if="$store.getters.paymentMethod == 'rped'" class="text-center py-4 text-capitalize">{{
                transaction.orderType }}</td>

              <td class="text-center py-4">
                <div v-if="transaction.status.toLowerCase() == 'match'">
                  {{ transaction.dateTransaction }}
                </div>
                <div v-else-if="transaction.status.toLowerCase() == 'cancel'" class="text-grey">
                  Tidak Tersedia
                </div>
                <div v-else class="text-grey">
                  Dalam Proses
                </div>
              </td>

              <td class="text-center py-4">
                <div v-if="!transaction.orderId">
                  {{ transaction.pgOrderId }}
                </div>
                <div v-else>
                  {{ transaction.orderId }}
                </div>
              </td>

              <td class="text-center py-4">
                <div v-if="transaction.status.toLowerCase() == 'match'">
                  {{ transaction.transactionId }}
                </div>
                <div v-else-if="transaction.status.toLowerCase() == 'cancel'" class="text-grey">
                  Tidak Tersedia
                </div>
                <div v-else class="text-grey">
                  Dalam Proses
                </div>
              </td>

              <td v-if="$store.getters.paymentMethod == 'rped'" class="text-center py-4">{{ transaction.product
              }}</td>

              <!-- <td v-if="$store.getters.paymentMethod == 'rped'" class="text-center py-4">JAK</td> -->

              <td class="text-center py-4">{{ transaction.totalGram }}</td>

              <td class="text-center">
                <div v-if="transaction.status.toLowerCase() == 'match'">
                  {{ utils.currencyFormat((currency == 'usd')
                    ? transaction.pricePerGramUsd
                    : transaction.pricePerGramIdr) }}
                </div>
                <div v-else-if="transaction.status.toLowerCase() == 'cancel'" class="text-grey">
                  Tidak Tersedia
                </div>
                <div v-else class="text-grey">
                  Dalam Proses
                </div>
              </td>

              <td class="text-center">
                <div v-if="transaction.status.toLowerCase() == 'match'">
                  {{ utils.currencyFormat((currency == 'usd')
                    ? transaction.metalValueOfTradeUsd
                    : transaction.metalValueOfTradeIdr) }}
                </div>
                <div v-else-if="transaction.status.toLowerCase() == 'cancel'" class="text-grey">
                  Tidak Tersedia
                </div>
                <div v-else class="text-grey">
                  Dalam Proses
                </div>
              </td>

              <td v-if="$store.getters.paymentMethod == 'rped'" class="text-center">
                {{ utils.currencyFormat((currency == 'usd')
                  ? transaction.feeUsd
                  : transaction.feeIdr) }}
              </td>

              <td v-if="$store.getters.paymentMethod == 'rped'" class="text-center">
                {{ utils.currencyFormat((currency == 'usd')
                  ? transaction.taxUsd
                  : transaction.taxIdr) }}
              </td>

              <td class="text-center">
                <div v-if="transaction.status.toLowerCase() == 'match'">
                  <div v-if="transaction.direction == 'buy'">
                    {{ utils.currencyFormat((currency == 'usd')
                      ? transaction.settlementAmountUsd
                      : transaction.settlementAmountIdr) }}
                  </div>
                  <div v-else>
                    {{ utils.currencyFormat((currency == 'usd')
                      ? transaction.finalAmountUsd
                      : transaction.finalAmountIdr) }}
                  </div>
                </div>
                <div v-else-if="transaction.status.toLowerCase() == 'cancel'" class="text-grey">
                  Tidak Tersedia
                </div>
                <div v-else class="text-grey">
                  Dalam Proses
                </div>
              </td>

              <td class="text-center">
                <div class="flex justify-center items-center gap-2">
                  <div>{{ transaction.statusShown }}</div>

                  <div>
                    <Tooltip v-if="transaction.status.toLowerCase() == 'process' && transaction.direction == 'sell'"
                      tooltipClass_prop="max-w-250 text-left" textPosition_prop="left" textAlign_prop="left">

                      <div v-if="!$store.state.glossaries.onProcessSettlement.body">
                        <Loader size_prop="10em"></Loader>
                      </div>

                      <div v-else>
                        <div class="mb-3">{{ $store.state.glossaries.onProcessSettlement.title }}</div>
                        <MarkdownRenderer :content="$store.state.glossaries.onProcessSettlement.body" />
                      </div>
                    </Tooltip>
                  </div>
                </div>
              </td>

              <td class="cursor-pointer text-center text-theme px-2" @click="showDetailTransaction(transaction)">
                Detail
              </td>

              <td v-if="environment == 'development'" class="text-right p-3">
                {{ utils.currencyFormat((currency == 'usd')
                  ? transaction.unrealizedPnlUsd
                  : transaction.unrealizedPnlIdr) }}
              </td>

              <td v-if="environment == 'development'" class="text-right p-3">
                {{ utils.currencyFormat((currency == 'usd')
                  ? transaction.realizedPnlUsd
                  : transaction.realizedPnlIdr) }}
              </td>
            </tr>
          </template>
        </tbody>

        <tbody v-else-if="transactionsStatus == 'error'">
          <tr v-if="transactions.length < 1">
            <td colspan="16" class="text-center">No data available in table</td>
          </tr>
        </tbody>

        <tfoot>

        </tfoot>
      </table>
    </div>

    <div class="flex justify-end text-right mb-2">
      <div class="">
        <Pagination2 ref="paginationTransactions" :totalData_prop="totalTransactions" @changePage="setTransactions">
        </Pagination2>
      </div>
    </div>

    <DetailTransaction ref="detailTransactionRef" :dataTransaction="detailTransaction">
    </DetailTransaction>
  </div>
</template>

<script>
import axios, { abortController } from '@/api/axios.js'
import Decimal from 'decimal.js'

import DetailTransaction from './DetailTransaction.vue'

import Alert from '../../alert-component/AlertComponent'

import ReportsNav from '@/components/reports/ReportsNav.vue'
import FilterContract from '@/components/FilterContract.vue'
import FilterDateAndType from '@/components/FilterDateAndType.vue'
import FilterOrderType from '@/components/FilterOrderType.vue'
import FilterTransactionStatus from './FilterTransactionStatus.vue'
import ButtonExportToCSV from '@/components/reports/ButtonExportToCSV.vue'
import Pagination2 from '@/components/Pagination2.vue'
import Loader from '@/components/Loader.vue'
import ExportAsButton from '../../ExportAsButton.vue'

import IconPDF from '@/components/icons/IconPDF.vue'
import IconInfo2 from '../../icons/IconInfo2.vue'
import Tooltip from '../../Tooltip.vue'
import MarkdownRenderer from '../../MarkdownRenderer.vue'

import utils from '../../../utils'

export default {
  name: 'Transactions',

  components: {
    DetailTransaction,
    ReportsNav,
    FilterContract,
    FilterDateAndType,
    FilterOrderType,
    FilterTransactionStatus,
    ButtonExportToCSV,
    Pagination2,
    Loader,
    ExportAsButton,

    IconPDF,
    IconInfo2,
    Tooltip,
    MarkdownRenderer
  },

  data() {
    return {
      utils: utils,
      environment: process.env.NODE_ENV,

      firstCallDone: false,

      transactions: [],
      transactionsStatus: 'loading',

      detailTransaction: {},

      totalTransactions: 0,
      orderTypeTransactions: 'all',
      transactionStatus: 'all',
      filterContractTransaction: [],
      selectedClientTransaction: 'all',
      filterDateAndTypeTransaction: {
        startDate: null,
        endDate: null,
        orderType: 'all'
      },
      invoiceLoading: [],

      // for export csv
      contractsParam_export: '',
      startDate_export: '',
      endDate_export: '',
      orderType_export: '',
      selectedClientTransaction_export: {},
    }
  },

  computed: {
    currency() {
      return this.$store.state.currency
    },

    hubs() {
      return this.$store.state.hubs
    },

    contracts() {
      return this.$store.state.contracts
    },

    accountLevel() {
      return this.$store.getters.getAccountLevel
    },

    streamingRate() {
      return this.$store.getters.getStreamingRate
    },
  },

  created() {
    const firstCall = setInterval(() => {
      if (this.contracts && this.accountLevel && this.hubs) {
        clearInterval(firstCall)

        this.firstCallDone = true
        this.setTransactions()
      }
    }, 1000)

    if (!this.$store.state.glossaries.onProcessSettlement.body) {
      this.$store.dispatch('glossaries/setOnProcessSettlement')
    }

    // initialize filter contract
    this.$store.state.filterContract.forEach((item) => {
      if (item.checked) {
        this.filterContractTransaction.push(item.contractId)
      }
    })
  },

  methods: {
    setTransactions(skip = 0, limit = 10, orderType = this.orderTypeTransactions, transactionStatus = this.transactionStatus) {
      if (!this.firstCallDone) {
        return
      }
      //transactions
      let hubs = this.hubs
      let contracts = this.contracts

      let startDate = this.filterDateAndTypeTransaction.startDate
      let endDate = this.filterDateAndTypeTransaction.endDate

      if (startDate) {
        startDate = `${startDate.getFullYear()}-${startDate.getMonth() + 1 < 10 ? '0' : ''}${startDate.getMonth() + 1}-${startDate.getDate() < 10 ? '0' : ''}${startDate.getDate()}`
      }

      if (endDate) {
        endDate = `${endDate.getFullYear()}-${endDate.getMonth() + 1 < 10 ? '0' : ''}${endDate.getMonth() + 1}-${endDate.getDate() < 10 ? '0' : ''}${endDate.getDate()}`
      }

      let selectedContracts = this.filterContractTransaction
      let contractsParam = ''

      let contractParamName = 'contract_id'
      if (this.accountLevel == 'ib' || this.accountLevel == 'fm') {
        contractParamName = 'contractId'
      }

      if (selectedContracts.length > 0) {
        selectedContracts.forEach((item) => {
          contractsParam = contractsParam + `${contractParamName}[]=${item}&`
        })
      }

      if (contractsParam == '') {
        contractsParam = `${contractParamName}[]=&`
      }

      // filter order type
      this.orderTypeTransactions = orderType
      let selectedOrderType = orderType
      if (this.orderTypeTransactions == 'all') {
        selectedOrderType = ''
      }

      // filter transaction status
      this.transactionStatus = transactionStatus
      let selectedTransactionStatus = transactionStatus
      if (this.transactionStatus == 'all') {
        selectedTransactionStatus = ''
      }

      // for export csv
      this.contractsParam_export = contractsParam
      this.startDate_export = startDate
      this.endDate_export = endDate
      this.orderType_export = selectedOrderType
      this.selectedClientTransaction_export = {
        hin_abx: this.selectedClientTransaction.hin_abx,
        ac_abx: this.selectedClientTransaction.ac_abx
      }

      let urlApi = ''
      if (this.accountLevel == 'ib' || this.accountLevel == 'fm' || this.accountLevel == 'ccp') {
        if (this.selectedClientTransaction == 'all') {
          urlApi = '/v2/rrs/transactions?offset=' + skip + '&limit=' + limit + '&' + contractsParam + 'dateStart=' + startDate + '&dateEnd=' + endDate + '&contract_id[]=100' + '&type=' + selectedOrderType + '&status=' + selectedTransactionStatus
        } else {
          urlApi = '/v2/rrs/transactions?offset=' + skip + '&limit=' + limit + '&' + 'hin=' + this.selectedClientTransaction.hin_abx + '&accountId=' + this.selectedClientTransaction.ac_abx + '&' + contractsParam + 'dateStart=' + startDate + '&dateEnd=' + endDate + '&type=' + selectedOrderType + '&status=' + selectedTransactionStatus
        }
      } else if (this.accountLevel == 'lp') {
        urlApi = '/v2/igx/market-maker/transaction?offset=' + skip + '&limit=' + limit + '&' + contractsParam + 'date_start=' + startDate + '&date_end=' + endDate + '&order_type=' + selectedOrderType
      } else {
        urlApi = '/v2/igx/transactions?offset=' + skip + '&limit=' + limit + '&' + contractsParam + 'date_start=' + startDate + '&date_end=' + endDate + '&order_type=' + selectedOrderType
      }

      this.transactionsStatus = 'loading'

      if (this.cancelTokenApiGetHinTransactions) {
        //cancel api get hin
        this.cancelTokenApiGetHinTransactions.controller.abort()
      }
      this.cancelTokenApiGetHinTransactions = abortController()

      if (this.cancelTokenApiGetTransactions) {
        //cancel api get transactions
        this.cancelTokenApiGetTransactions.controller.abort()
      }
      this.cancelTokenApiGetTransactions = abortController()

      axios.post(urlApi, {
        user_id: this.$store.state.userId
      }, {
        signal: this.cancelTokenApiGetTransactions.signal,
      }).then(response => {
        this.transactions = []

        this.totalTransactions = response.data.data.count

        let transactions = response.data.data.body
        if (this.accountLevel == 'ib' || this.accountLevel == 'fm') {
          transactions = response.data.data.body
        }

        let sortedTransactions = transactions.sort((a, b) => new Date(b.attributes.createdAt) - new Date(a.attributes.createdAt))
        // sortedTransactions = this.paginationOrder(sortedTransactions)

        if (transactions.length < 1) {
          this.transactionsStatus = 'idle'
        }

        function qaFunction(contractId, metalvalueOfTradeUsd, metalvalueOfTradeIdr, settlementAmountUsd, settlementAmountIdr) {
          this.contractId = contractId
          this.metalvalueOfTradeUsd = metalvalueOfTradeUsd
          this.metalvalueOfTradeIdr = metalvalueOfTradeIdr
          this.settlementAmountUsd = settlementAmountUsd
          this.settlementAmountIdr = settlementAmountIdr
        }
        const arrayQA = []

        for (let i = 0; i < sortedTransactions.length; i++) {
          const contractConfig = this.$store.state.contractConfigs[sortedTransactions[i].attributes.contractId]

          let contract = contracts.find(obj => obj.id == sortedTransactions[i].attributes.contractId)

          let rate = sortedTransactions[i].attributes.rate || 0
          if (rate == 0) {
            rate = (sortedTransactions[i].attributes.direction == 'sell') ? this.streamingRate.streamSell : this.streamingRate.streamBuy
          }

          const weight = contractConfig.weightInGram

          let tempArray = []
          let hub = '-'
          if (hubs) {
            hub = hubs.find(obj => obj.id == contract.attributes.hubId)
            hub = hub.attributes.iata
          }

          const dateObject = (dateParam) => {
            return {
              year: dateParam.getFullYear(),
              month: (dateParam.getMonth() + 1 < 10) ? `0${dateParam.getMonth() + 1}` : dateParam.getMonth() + 1,
              date: (dateParam.getDate() < 10) ? `0${dateParam.getDate()}` : dateParam.getDate(),
              hours: (dateParam.getHours() < 10) ? `0${dateParam.getHours()}` : dateParam.getHours(),
              minutes: (dateParam.getMinutes() < 10) ? `0${dateParam.getMinutes()}` : dateParam.getMinutes()
            }
          }
          const dateCreatedAt = new Date(sortedTransactions[i].attributes.createdAt)
          const date = sortedTransactions[i].attributes.createdAt ? `${dateObject(dateCreatedAt).year}/${dateObject(dateCreatedAt).month}/${dateObject(dateCreatedAt).date} ${dateObject(dateCreatedAt).hours}:${dateObject(dateCreatedAt).minutes}` : '-'

          const dateTransactionAt = new Date(sortedTransactions[i].attributes.transactionAt)
          const dateTransaction = sortedTransactions[i].attributes.transactionAt ? `${dateObject(dateTransactionAt).year}/${dateObject(dateTransactionAt).month}/${dateObject(dateTransactionAt).date} ${dateObject(dateTransactionAt).hours}:${dateObject(dateTransactionAt).minutes}` : '-'

          const transactionId = sortedTransactions[i].id

          const quantityFromTransaction = sortedTransactions[i].attributes.status != 'match' ? sortedTransactions[i].attributes.orderQuantity : sortedTransactions[i].attributes.quantity

          const quantity = Decimal.div(quantityFromTransaction, contractConfig.weightCorrection).toNumber()

          const totalGram = Decimal.mul(weight, quantityFromTransaction).dividedBy(contractConfig.weightCorrection).toNumber()

          const metalValueOfTradeUsd = new Decimal(sortedTransactions[i].attributes.metalValueOfTrade).toFixed(this.$store.state.fractionDigit.usd)
          const metalValueOfTradeIdr = new Decimal(sortedTransactions[i].attributes.metalValueOfTradeIdr).toFixed(this.$store.state.fractionDigit.idr)

          const pricePerGramUsd = sortedTransactions[i].attributes.quantity == 0 ? 0 : Decimal.div(sortedTransactions[i].attributes.metalValueOfTrade, totalGram).toFixed(this.$store.state.fractionDigit.usd)
          const pricePerGramIdr = sortedTransactions[i].attributes.quantity == 0 ? 0 : Decimal.div(sortedTransactions[i].attributes.metalValueOfTrade, totalGram).times(rate).toFixed(this.$store.state.fractionDigit.idr)

          const settlementAmountUsd = new Decimal(sortedTransactions[i].attributes.settlementAmount).toFixed(this.$store.state.fractionDigit.usd)
          const settlementAmountIdr = new Decimal(sortedTransactions[i].attributes.settlementAmountIdr).toFixed(this.$store.state.fractionDigit.idr)

          const adminFeeUsd = new Decimal(sortedTransactions[i].attributes.pgAdminFee).dividedBy(rate).toFixed(this.$store.state.fractionDigit.usd)
          const adminFeeIdr = new Decimal(sortedTransactions[i].attributes.pgAdminFee).toFixed(this.$store.state.fractionDigit.idr)

          const feeUsd = new Decimal(sortedTransactions[i].attributes.fee).toFixed(this.$store.state.fractionDigit.feeUsd)
          const feeIdr = new Decimal(sortedTransactions[i].attributes.feeIdr).toFixed(this.$store.state.fractionDigit.feeIdr)

          const taxUsd = new Decimal(sortedTransactions[i].attributes.tax).toFixed(this.$store.state.fractionDigit.taxUsd)
          const taxIdr = new Decimal(sortedTransactions[i].attributes.taxIdr).toFixed(this.$store.state.fractionDigit.taxIdr)
          
          let fxBufferUsd
          if (sortedTransactions[i].attributes.fxBuffer) {
            fxBufferUsd = new Decimal(sortedTransactions[i].attributes.fxBuffer).toFixed(this.$store.state.fractionDigit.fxBufferUsd)
          } else if (sortedTransactions[i].attributes.fxBufferIdr) {
            fxBufferUsd = Decimal.div(sortedTransactions[i].attributes.fxBufferIdr, rate).toFixed(this.$store.state.fractionDigit.fxBufferUsd)
          } else {
            fxBufferUsd = new Decimal(0)
          }

          let fxBufferIdr
          if (sortedTransactions[i].attributes.fxBufferIdr) {
            fxBufferIdr = new Decimal(sortedTransactions[i].attributes.fxBufferIdr).toFixed(this.$store.state.fractionDigit.fxBufferIdr)
          } else {
            fxBufferIdr = new Decimal(0)
          }

          const finalAmountUsd = new Decimal(sortedTransactions[i].attributes.paymentTotalUsd).toFixed(this.$store.state.fractionDigit.usd)
          const finalAmountIdr = new Decimal(sortedTransactions[i].attributes.paymentTotalIdr).toFixed(this.$store.state.fractionDigit.idr)

          const status = sortedTransactions[i].attributes.status
          const statusMapBuy = {
            'match': 'Matched',
            'cancel': 'Cancelled',
            'pending': 'Waiting for Payment',
            'on_process': 'On Process',
          }
          const statusMapSell = {
            'on_process': 'On Process',
            'on_settlement': 'On Settlement',
            'match': 'Matched',
            'cancel': 'Cancelled',
          }
          const statusShown = sortedTransactions[i].attributes.direction == 'buy' ? statusMapBuy[status] || '-' : statusMapSell[status] || '-'
          
          // variable to show/hide profit in detail transaction
          let hideProfit = false
          let profitIdr, profitUsd, profitIdrSign, profitUsdSign
          if (sortedTransactions[i].attributes.direction == 'buy') {
            profitIdr = '-'
            profitUsd = '-'
            profitIdrSign = ''
            profitUsdSign = ''
          } else {
            if (status == 'match') {
              profitIdr = new Decimal(sortedTransactions[i].attributes.realizedPnlIdr)
              profitUsd = new Decimal(sortedTransactions[i].attributes.realizedPnlUsd)
            } else if (!sortedTransactions[i].attributes.unrealizedPnlIdr || !sortedTransactions[i].attributes.unrealizedPnlUsd) {
              profitIdr = new Decimal(0)
              profitUsd = new Decimal(0)
              hideProfit = true
            } else {
              profitIdr = new Decimal(sortedTransactions[i].attributes.unrealizedPnlIdr)
              profitUsd = new Decimal(sortedTransactions[i].attributes.unrealizedPnlUsd)
            }
            profitIdrSign = profitIdr.equals(0) ? '' : profitIdr.lessThan(0) ? '-' : '+'
            profitUsdSign = profitUsd.equals(0) ? '' : profitUsd.lessThan(0) ? '-' : '+'
            profitIdr = profitIdr.abs().toFixed(this.$store.state.fractionDigit.idr)
            profitUsd = profitUsd.abs().toFixed(this.$store.state.fractionDigit.usd)
          }

          tempArray = {
            id: sortedTransactions[i].id,
            direction: sortedTransactions[i].attributes.direction,
            orderId: sortedTransactions[i].attributes.orderId,
            orderMatchId: sortedTransactions[i].attributes.orderMatchId,
            transactionId: transactionId,
            contractId: sortedTransactions[i].attributes.contractId,
            pgOrderId: sortedTransactions[i].attributes.pgOrderId,
            date: date,
            dateTransaction: dateTransaction,
            hin: (this.accountLevel == 'ib' || this.accountLevel == 'fm' || this.accountLevel == 'ccp') ? 'loadingTemp' : this.$store.getters.getHin,
            product: contractConfig.name,
            hub: hub,
            orderType: sortedTransactions[i].attributes.orderType,
            quantity: quantity,
            totalGram: totalGram,
            pricePerGramUsd: pricePerGramUsd,
            pricePerGramIdr: pricePerGramIdr,
            metalValueOfTradeUsd: metalValueOfTradeUsd,
            metalValueOfTradeIdr: metalValueOfTradeIdr,
            feeUsd: feeUsd,
            feeIdr: feeIdr,
            taxUsd: taxUsd,
            taxIdr: taxIdr,
            storageFee: '0',
            fxBufferUsd: fxBufferUsd,
            fxBufferIdr: fxBufferIdr,
            adminFeeUsd: adminFeeUsd,
            adminFeeIdr: adminFeeIdr,
            settlementAmountUsd: settlementAmountUsd,
            settlementAmountIdr: settlementAmountIdr,
            finalAmountUsd: finalAmountUsd,
            finalAmountIdr: finalAmountIdr,
            status: status,
            statusShown: statusShown,
            transferTo: sortedTransactions[i].attributes.transferTo,
            profitIdr: profitIdr,
            profitUsd: profitUsd,
            profitIdrSign: profitIdrSign,
            profitUsdSign: profitUsdSign,
            hideProfit: hideProfit,
            // dev debugging
            unrealizedPnlIdr: sortedTransactions[i].attributes.unrealizedPnlIdr,
            unrealizedPnlUsd: sortedTransactions[i].attributes.unrealizedPnlUsd,
            realizedPnlIdr: sortedTransactions[i].attributes.realizedPnlIdr,
            realizedPnlUsd: sortedTransactions[i].attributes.realizedPnlUsd,
          }

          if (process.env.NODE_ENV == 'development') {
            arrayQA.push(new qaFunction(sortedTransactions[i].attributes.contractId, metalValueOfTradeUsd, metalValueOfTradeIdr, settlementAmountUsd, settlementAmountIdr))
          }

          // this.transactions[i] = tempArray

          this.$set(this.transactions, i, tempArray)

          if (this.accountLevel == 'ib' || this.accountLevel == 'fm' || this.accountLevel == 'ccp') {
            axios.get('/v2/rrs/get/hin?accountId=' + sortedTransactions[i].attributes.accountId, {
              signal: this.cancelTokenApiGetHinTransactions.signal
            }).then(response2 => {
              this.$set(this.transactions, i, {
                ...this.transactions[i],
                'hin': response2.data.data.body
              })
            }).catch(error => {
            })
          }
        }

        // Buat Saskia QA. Dev only
        if (process.env.NODE_ENV == 'development') {
          console.table(arrayQA)
        }

        this.transactionsStatus = 'success'
      }).catch(error => {
        this.transactionsStatus = 'error'
        console.error(error)
      })
    },

    changeFilterClientTransaction(clientData) {
      this.selectedClientTransaction = clientData
      this.setTransactions()
    },

    changeFilterContractTransaction(selectedContracts) {
      this.filterContractTransaction = selectedContracts
      this.$refs.paginationTransactions.resetPagination()
      this.setTransactions()
    },

    changeFilterDateAndTypeTransaction(data) {
      this.filterDateAndTypeTransaction = data
      this.setTransactions()
    },

    showDetailTransaction(transaction) {
      this.detailTransaction = transaction
      this.$refs.detailTransactionRef.openDetailTransaction()
    },

    invoice(orderMatchId, direction, transactionStatus, transactionRef) {
      // If Transaction Status == On Process, cannot download pdf
      if (transactionStatus == 'On Process') {
        return false
      }

      this.invoiceLoading.push(transactionRef)
      axios({
        method: 'POST',
        url: process.env.VUE_APP_BACKEND_URL + '/igx/reports/pdf/transaction_invoice',
        // responseType: 'arraybuffer',
        data: {
          order_match_id: orderMatchId,
          direction: direction,
        },
      }).then(response => {
        let datanya = response.data.data.body.data

        // let byte = this.base64ToArrayBuffer(datanya)
        const arrTes = new Uint8Array(datanya)
        let blob = new Blob([arrTes], { type: "application/pdf" })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        let fileName = 'trade_confirmation_invoice-' + orderMatchId
        link.download = fileName
        link.click()

        let indexLoading = this.invoiceLoading.indexOf(orderMatchId)
        this.invoiceLoading.splice(indexLoading, 1)

      }).catch(error => {

        if (error.response.data.data.status_code == 'FileNotExist') {
          Alert.open({
            type: 'info',
            title: 'Dokumen sedang Dipersiapkan',
            description: 'Dokumen PDF Anda sedang diproses, Silakan coba beberapa saat lagi (Estimasi 1-2 menit)',
          })
        } else {
          Alert.open({
            type: 'error',
            title: 'Gagal Mengunduh Dokumen',
            description: 'Terjadi kesalahan saat mengunduh dokumen PDF, silakan coba beberapa saat lagi',
          })
        }

        let indexLoading = this.invoiceLoading.indexOf(orderMatchId)
        this.invoiceLoading.splice(indexLoading, 1)
      })
    },
  }
}
</script>

<style scoped>
table {
  clip-path: inset(0 round 10px);
}
</style>
